import { safeImageUrl } from './safeUrl';

function SafeImage({ src, alt = '', ...props }) {
  const safeSrc = safeImageUrl(src);
  if (!safeSrc) return null;
  return <img {...props} src={safeSrc} alt={alt} />;
}

export default SafeImage;
